import React from "react";
import { Alert, Form, Icon, Button, Row, Col, Upload, message } from "antd";
import get from "lodash/get";
import { connect } from "react-redux";

import {
  specimenFileSubjectUpload,
  specimenSchemaDownload,
} from "../../../api/requests";
import {
  getSpecimenSampleCreatePermission,
  getSpecimenSampleUpdatePermission,
  getUserTimezone,
  getUserShortTimezone,
} from "../../../reducers/user/selectors";

import classes from "./SpecimenSample.css";
import { logout } from "../../../reducers/user/actions";
import FileLink from "../../../components/FileLink/FileLink";

class ResultUploadForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      loadingSchema: false,
      requestResult: {},
    };
  }

  downloadSchema = async () => {
    try {
      this.setState(() => ({
        loadingSchema: true,
      }));

      let data = null;

      const response = await specimenSchemaDownload();
      data = response.data;

      const blob = new Blob([data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `specimen-sample-example.csv`;
      link.click();
    } catch (e) {
      message.error("Error");
      console.log(e);
    }

    this.setState(() => ({
      loadingSchema: false,
    }));
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const formData = new FormData();
          if (values.result_file && values.result_file.file) {
            formData.append("result_file", values.result_file.file);
          }
          // formData.append('location_id', values.location_id);
          await specimenFileSubjectUpload(formData, {
            subjectID: this.props.subjectID,
            id: this.props.id,
          });

          this.setState({
            isLoading: false,
            requestResult: { type: "success", message: "Success" },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", "Error"),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h5 className="headline-default">Upload Result File</h5>

          <Row gutter={12}>
            <Col md={12}>
              <label>
                <b>Select .csv</b>
                <Form.Item>
                  {getFieldDecorator("result_file", {
                    initialValue: get(this.props, "result_file", ""),
                  })(
                    <Upload
                      accept=".csv"
                      action=""
                      beforeUpload={() => false}
                      multiple={false}
                      fileList={get(
                        this.props.form.getFieldValue("result_file"),
                        "fileList",
                        []
                      ).slice(-1)}
                    >
                      <Button>
                        <Icon type="upload" />
                        {!this.props.form.getFieldValue("result_file") &&
                        this.props.url
                          ? "Change file"
                          : "Upload Result File"}
                      </Button>
                    </Upload>
                  )}
                </Form.Item>
              </label>

              {!this.props.form.getFieldValue("result_file") && this.props.url && (
                <div>
                  <FileLink
                    url={this.props.url}
                    text={this.props.url.split('/')[this.props.url.split('/').length - 1]}
                  />
                  <br />
                  <br />
                </div>
              )}
            </Col>

            {/*<Col md={24}>
              .CSV example:{" "}
              <Button
                onClick={() => this.downloadSchema()}
                disabled={this.state.loadingSchema}
                loading={this.state.loadingSchema}
                type="primary"
                size="small"
              >
                Download
              </Button>
              <br />
              <br />
            </Col>*/}
          </Row>

          <div style={{ width: "171px" }}>
            {requestResult.type && (
              <Alert
                message={requestResult.message}
                type={requestResult.type}
                className={classes.submitResult}
              />
            )}
          </div>

          <div className={classes.actionWrapper}>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className={classes.submitButton}
              >
                Save
                {isLoading && <Icon type="loading" />}
              </Button>
              &nbsp; &nbsp;
            </Form.Item>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  specimenSampleCreatePermission: getSpecimenSampleCreatePermission(state),
  specimenSampleUpdatePermission: getSpecimenSampleUpdatePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "ResultUploadForm" })(
  connect(mapStateToProps, mapDispatchToProps)(ResultUploadForm)
);



// WEBPACK FOOTER //
// ./src/containers/PatientProfile/SpecimenSample/ResultUploadForm.js